let delete_proposal = require( './delete-proposal' );

let popups = (function( $ ) {

	let $anchors;

	let _init = function() {
		$anchors = $( 'a.popup' );

		_setup_non_ajax_popups();

		if ( $anchors.length > 0 ) {
			$anchors.on( 'click', _show_popup );
		}
	};

	let _setup_non_ajax_popups = function() {
		let $popups = $( '.crate-popup' );

		if ( $popups.length <= 0 ) {
			return;
		}

		$( '.crate-popup-wrap' ).on( 'click', _exit_popup_no_ajax );

		$popups.on( 'click', function( e ) {
			e.stopPropagation();
		} );

		$popups.find( 'a.exit' ).on( 'click', _exit_popup_no_ajax );
	};

	let _show_popup = function( e ) {
		e.preventDefault();

		if ( $( this ).hasClass( 'no-ajax' ) ) {
			let $popup = $( '#' + $( this ).data( 'popup' ) );

			_show_popup_no_ajax( $popup );
			return;
		}

		let data = {
			action: 'crate_get_popup',
			nonce: ScriptData.crate_get_popup_nonce,
			popup: $( this ).data( 'popup' ),
			args : $( this ).data( 'popup-data' ),
		};

		$.post( ScriptData.ajaxurl, data, _show_popup_response );
	};

	let _show_popup_no_ajax = function( $popup ) {
		$( 'body' ).addClass( 'open-popup' );
		$popup.fadeIn();
	};

	let _exit_popup_no_ajax = function( e ) {
		e.preventDefault();
		$( 'body' ).removeClass( 'open-popup' );
		$( this ).closest( '.crate-popup-wrap' ).fadeOut();
	};

	let _show_popup_response = function( response ) {
		if ( ! response.success ) {
			return;
		}

		$( 'body' ).append( response.popup ).addClass( 'open-popup' );

		$( '.crate-popup' ).find( 'a.exit' ).on( 'click', _exit_popup );
		delete_proposal.init();
	};

	let _exit_popup = function( e ) {
		e.preventDefault();

		$( '.crate-popup' ).find( 'a.exit' ).off( 'click', _exit_popup );
		$( this ).closest( '.crate-popup-wrap' ).remove();
		$( 'body' ).removeClass( 'open-popup' );
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = popups;